import React from 'react';

const HeaderIcon = () => (
  <svg
    viewBox="0 0 455 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-full max-w-[455px] h-auto"
    preserveAspectRatio="xMinYMid meet"
  >
    <defs>
      <linearGradient id="circleGradient" x1="6.46305" y1="11.7963" x2="30.555" y2="11.7963" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFA8D1" />
        <stop offset="0.475962" stopColor="#C3B1FF" />
        <stop offset="1" stopColor="#AEE2FF" />
      </linearGradient>
      <linearGradient id="textGradient" x1="125.414" y1="10.1111" x2="436.351" y2="10.1111" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFA8D1" />
        <stop offset="0.475962" stopColor="#C3B1FF" />
        <stop offset="1" stopColor="#AEE2FF" />
      </linearGradient>
    </defs>
    <circle cx="16" cy="19.5" r="16" fill="url(#circleGradient)" />
    <circle cx="16" cy="19.5" r="8" fill="#473256" />
    <text
      fill="url(#textGradient)"
      fontFamily="Inter"
      fontSize="32"
      fontWeight="500"
      x="42"
      y="31"
    >
      MEET THE BABY UNICORN
    </text>
  </svg>
);

const Bullet = ({ id }) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id={`grad-${id}`} x1="2.4" y1="3.1" x2="11.5" y2="3.1" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFA8D1" />
        <stop offset="0.475962" stopColor="#C3B1FF" />
        <stop offset="1" stopColor="#AEE2FF" />
      </linearGradient>
    </defs>
    <circle cx="6" cy="6" r="6" fill={`url(#grad-${id})`} />
  </svg>
);

const AIFriendSection = () => {
  const features = [
    "Talk and respond to children in real-time",
    "Teach and guide them through songs, stories, languages, and simple concepts",
    "Foster creativity through conversation and imagination",
    "Provide emotional comfort and companionship at bedtime and throughout the day",
    "Grow with your child, adapting to their learning pace and emotional needs"
  ];

  return (
    <section
      className="relative flex justify-center items-center px-72 py-28 mx-auto w-full max-w-none rounded-3xl min-h-[971px] max-xl:px-20 max-lg:px-12 max-md:px-8 max-md:py-16 max-md:rounded-2xl max-sm:px-5 max-sm:py-10"
      style={{
        backgroundImage: "url('/Rectangle 43.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="absolute inset-0 bg-black/40 z-0" />

      <div className="flex relative gap-16 items-start w-full h-[743px] max-w-[1344px] max-md:flex-col max-md:gap-10 max-md:max-w-full max-md:h-auto z-10">
        {/* Logo: Desktop/Mobile Top, Hidden on Tablet */}
        <div className="flex flex-col gap-8 items-start h-[743px] w-[663px] max-md:w-full max-md:h-auto">
          <div className="flex gap-2.5 justify-center items-center max-sm:gap-1.5 max-sm:scale-90 md:hidden lg:flex">
            <div className="w-full max-w-[280px] max-sm:max-w-[220px]">
              <HeaderIcon />
            </div>
          </div>

          <header>
            <h1 className="font-fredoka text-6xl font-bold tracking-wider text-white leading-[72px] w-[629px] max-md:w-full max-md:text-5xl max-md:leading-[56px] max-sm:text-3xl max-sm:leading-10 max-sm:tracking-wide">
              <span>Your Child's Magical </span>
              <span className="bg-gradient-to-r   bg-clip-text text-transparent">
                AI Friend
              </span>
            </h1>
          </header>

          <p className="self-stretch text-2xl leading-8 text-neutral-100 max-md:text-xl max-md:leading-7 max-sm:text-base max-sm:leading-6">
            This isn't just a toy. It's a companion. Our AI Baby Unicorn is a
            soft, huggable friend powered by intelligent technology — designed
            to:
          </p>

          <div className="flex gap-3 items-start self-stretch max-sm:gap-2">
            <div className="relative left-1.5 top-3.5 h-[241px] w-[0.5px] bg-gradient-to-b  max-sm:left-1 max-sm:top-3" />
            <div className="flex flex-col gap-3 items-start flex-[1_0_0]">
              {features.map((feature, index) => (
                <div key={index} className="flex gap-4 items-start self-stretch max-sm:gap-3">
                  <div className="pt-2">
                    <Bullet id={index} />
                  </div>
                  <p className="text-2xl leading-8 flex-[1_0_0] text-neutral-100 max-md:text-xl max-md:leading-7 max-sm:text-base max-sm:leading-6">
                    {feature}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <p className="self-stretch text-2xl leading-8 text-neutral-100 max-md:text-xl max-md:leading-7 max-sm:text-base max-sm:leading-6">
            It's more than smart — it's safe, sweet, and truly magical.
          </p>

          {/* Logo: Tablet Only, Below Content, Larger */}
          <div className="hidden md:flex lg:hidden w-full justify-center mt-8">
            <div className="w-full max-w-[380px]">
              <HeaderIcon />
            </div>
          </div>
        </div>

        <div className="flex flex-1 justify-center items-center max-md:justify-center max-md:w-full">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/be72fc183760b2665041b431dc081f2d6ae6f270?placeholderIfAbsent=true&apiKey=0c11d46dd7d64d7a84bf3e17dbee5689"
            alt="AI Baby Unicorn"
            className="w-[619px] h-[707px] object-contain max-w-full max-h-full max-md:w-[90%] max-md:h-auto max-sm:w-full max-sm:h-auto"
          />
        </div>
      </div>

      <div className="absolute right-[-285px] top-24 w-[570px] h-[570px] rounded-full bg-pink-400 opacity-60 blur-[400px] z-0" />
    </section>
  );
};

export default AIFriendSection;
